import { useEffect, useState } from "react";
import { AddOnApi } from "../../api/AddOn.api";
import AddOn from "../../models/AddOn.model";
import { useAppSelector } from "../../store";
import moment, { Moment } from "moment";
import { PaymentApi } from "../../api/Payment.api";
import { useNavigate } from "react-router-dom";
import { UserApi } from "../../api/User.api";
import UserCoupon from "../../models/UserCoupon.model";
import { Products } from "../../commons/Const";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export default function AddOnViewModel() {

  const navigate = useNavigate();

  //const user = useAppSelector(state => state.app.user);
  const queryClient = useQueryClient();
  const {data: user} = useQuery({
    queryKey: ['user'],
    queryFn: UserApi.getMe,
  })

  const [addOnList, setAddOnList] = useState<AddOn[]>([]);

  const [period, setPeriod] = useState<number|null>(null);
  const [payMethod, setPayMethod] = useState(0);
  const [amount, setAmount] = useState(0);

  const [round, setRound] = useState(0);

  const [userCoupon, setCoupon] = useState<UserCoupon|null>(null)

  const [disable, setDisable] = useState(false);

  const [isPaying, setIsPaying] = useState(false);

  const [enterTime, setEnterTime] = useState<Moment>(moment());

  useEffect(() => {
    getAddOnList();
    //getUserSubscription();
    
    setEnterTime(moment());
  }, [])

  useEffect(() => {
    if(!user) return;

    getUserSubscription();
    getCoupon();
  }, [user]);

  useEffect(() => {

    let amount = addOnList.filter(v => v.isSelected).map(v => v.price).reduce((a, c) => a + c, 0);
    setAmount(amount);
    
  }, [addOnList])

  const toogleAddOn = (addOn: AddOn) => {
    
    if(addOn.id === 10) {
      setAddOnList(addOnList.map(value => {
        if(value.id === addOn.id) value.isSelected = !value.isSelected;
        else value.isSelected = false;
        
        return value;
      }))
    }
    else {
      setAddOnList(addOnList.map(value => {
        if(value.id === addOn.id) value.isSelected = !value.isSelected;

        if(value.id === 10) value.isSelected = false;
        
        return value;
      }))
    }
  }

  const getAddOnList = async () => {
    try {
      const result = await AddOnApi.getAddOnList();

      setDisable(result.disable);
      setAddOnList(result.addOnList);
    } catch (error) {
      console.error(error);
    }
  }

  const getUserSubscription = async () => {
    try {
      const result = await UserApi.getSubscription();

      const isSpecial = result.paymentHistoryList.find(v => v.type === 3) !== undefined;
      console.log('user', user)
      const additionalMonths = user?.additionalMonths ?? 0;

      console.log('additionalMonths', additionalMonths);

      const latestPaymentHistory = result.paymentHistoryList.filter(v => v.paidAt !== null)?.sort((a, b) => {
        return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
      })[0];

      setPeriod(isSpecial && result.round === 1 ? -1 : ((latestPaymentHistory?.startRound ?? 0) + additionalMonths));

    } catch (error) {
      console.error(error)
    }
  }

  const getCoupon = async () => {
    try {
      
      const couponList = await UserApi.getCouponList();

      
      if(couponList.length !== 0 && couponList[0].usedAt === null) {
        setCoupon(couponList[0])
      }

    } catch (error) {
      console.error(error)
    }
  }

  const order = async () => {

    const progressMinutes = moment().diff(enterTime, 'minutes');

    if(progressMinutes > 10) {
      window.alert('유효시간 만료로 새로 갱신합니다.')
      window.location.reload();
      return;
    }

    if(user === undefined || user === null) return

    const selectedAddonList = addOnList.filter(v => v.isSelected);

    if(selectedAddonList.length === 0) return;

    let productName = selectedAddonList[0].name;

    let amount = selectedAddonList.map(v => v.price + v.vat).reduce((a, c) => a + c, 0)

    if(userCoupon !== null) {
      amount = Math.max(0, amount - userCoupon.coupon.value - (userCoupon.coupon.value / 10))
    }

    if(process.env.REACT_APP_IS_TEST === 'true') {
      amount = (amount / 100);
    }

    if(amount === 0) {
      const result = await PaymentApi.paymentAddOn(selectedAddonList, -1, null, userCoupon?.id)

      queryClient.invalidateQueries({queryKey: ['user']});
      
      navigate('/payment/complete', {state: result});

      return;
    }

    let paymentData: any = {};

    if(payMethod === 0) {
      paymentData = {
        pg: process.env.REACT_APP_PG_CARD,
        pay_method : 'card',
        merchant_uid : `${user.phone}-${new Date().getTime()}`,
        name : selectedAddonList.length === 1 ? productName : `${productName} 외 ${selectedAddonList.length - 1}개`,
        amount : amount,
        buyer_name : user.name,
        buyer_tel : user.phone,
      }
    }
    else if(payMethod === 1) {
      paymentData = {
        pg: process.env.REACT_APP_PG_PHONE,
        pay_method : 'phone',
        merchant_uid : `${user.phone}-${new Date().getTime()}`,
        name : selectedAddonList.length === 1 ? productName : `${productName} 외 ${selectedAddonList.length - 1}개`,
        amount : amount,
        buyer_name : user.name,
        buyer_tel : user.phone,
        buyer_email : '',
      }
    }

    try {

      setIsPaying(true);
      const paymentResult = await requestPayment(paymentData);

      const result = await PaymentApi.paymentAddOn(selectedAddonList, payMethod, paymentResult.imp_uid, userCoupon?.id)

      navigate('/payment/complete', {state: result});
  
    } catch (error) {
      //console.log(error)
      if(error instanceof Error) {
        
      };
      
    } finally {
      setIsPaying(false);
    }
    
  }

  const requestPayment = async (data: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      const { IMP } = window
      IMP.init("imp84428497");

      IMP.request_pay(data, (response: any) => {
        if(response.success) {
          resolve(response);
        }
        else {
          reject(response);
        }
      });
    })
  }

  return {
    user,
    amount, period, disable,
    userCoupon,
    round,
    addOnList, toogleAddOn,
    payMethod, setPayMethod,
    isPaying,
    order,
  }
}